/**
 * Homelya — total do carrinho
 *
 * Ao mudar a quantidade de um item (página do carrinho ou pop-up):
 *   1) calcula na hora:  total do produto = preço unitário x quantidade
 *                        Valor Total      = soma dos totais dos produtos
 *   2) envia a nova quantidade ao Shopify (/cart/change.js)
 *   3) confirma os valores com a resposta do Shopify.
 */
(function () {
  if (window.__homelyaCartTotals) return;
  window.__homelyaCartTotals = true;

  const SCOPE = 'cart-items, cart-drawer-items';
  const timers = {};
  let currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';

  const money = (cents) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format((cents || 0) / 100);

  const rows = () => document.querySelectorAll('.cart-item');
  const qtyInput = (row) => row.querySelector('.quantity__input');

  function setLineTotal(row, cents) {
    const prices = row.querySelectorAll('.cart-item__totals .price');
    const target = prices[prices.length - 1];
    if (target) target.textContent = money(cents);
  }

  // A página do carrinho e o pop-up existem ao mesmo tempo: cada um tem o seu total.
  function setGrandTotal(cents, which) {
    const targets = {
      page: '#main-cart-footer .totals__total-value',
      drawer: '#CartDrawer .totals__total-value',
    };
    (which ? [which] : ['page', 'drawer']).forEach((k) => {
      document.querySelectorAll(targets[k]).forEach((el) => {
        el.textContent = money(cents);
      });
    });
  }

  // Cálculo local: preço x quantidade de cada linha, e soma por tela (sem misturar página e pop-up).
  function recalcFromDom() {
    const sums = { page: 0, drawer: 0 };
    rows().forEach((row) => {
      const input = qtyInput(row);
      if (!input) return;
      const unit = parseInt(input.dataset.unitPrice, 10);
      const qty = parseInt(input.value, 10);
      if (isNaN(unit) || isNaN(qty)) return;
      const line = unit * qty;
      setLineTotal(row, line);
      sums[row.closest('cart-drawer-items') ? 'drawer' : 'page'] += line;
    });
    if (document.getElementById('main-cart-footer')) setGrandTotal(sums.page, 'page');
    if (document.getElementById('CartDrawer')) setGrandTotal(sums.drawer, 'drawer');
  }

  function applyCart(cart) {
    if (!cart || !cart.items) return;
    currency = cart.currency || currency;
    rows().forEach((row) => {
      const input = qtyInput(row);
      const item = input && cart.items.find((i) => i.key === input.dataset.quantityLineKey);
      if (!item) return;
      input.value = item.quantity;
      input.setAttribute('value', item.quantity);
      input.dataset.unitPrice = item.final_price;
      setLineTotal(row, item.final_line_price);
    });
    setGrandTotal(cart.total_price);

    // contador do ícone do carrinho
    if (window.customElements.get('add-to-cart-only')) {
      const AddOnly = customElements.get('add-to-cart-only');
      if (AddOnly.updateCartIcon) AddOnly.updateCartIcon();
    }
  }

  const seq = {};

  function sendChange(input) {
    const key = input.dataset.quantityLineKey;
    const quantity = parseInt(input.value, 10);
    if (!key || isNaN(quantity) || quantity < 0) return;
    const mySeq = (seq[key] = (seq[key] || 0) + 1);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then((cart) => {
        if (cart.status || cart.errors) throw new Error(cart.description || cart.errors);
        // Se o cliente já mudou a quantidade de novo, esta resposta é antiga: a mais nova cuida disso.
        if (mySeq !== seq[key] || parseInt(input.value, 10) !== quantity) return;
        if (quantity === 0 || cart.item_count === 0) {
          // item removido: redesenha a lista pelo fluxo do tema
          if (cart.item_count === 0 || document.getElementById('main-cart-footer')) {
            window.location.reload();
          } else if (window.homelyaRefreshCart) {
            window.homelyaRefreshCart();
          }
          return;
        }
        applyCart(cart);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
        }
      })
      .catch((e) => {
        console.error(e);
        fetch('/cart.js', { cache: 'no-store' })
          .then((r) => r.json())
          .then(applyCart)
          .catch(() => {});
      });
  }

  // Captura o evento antes do fluxo padrão do tema (que não estava atualizando).
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('quantity__input')) return;
      if (!input.closest(SCOPE)) return;

      event.stopImmediatePropagation();
      const value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) return;

      recalcFromDom();
      const key = input.dataset.quantityLineKey;
      clearTimeout(timers[key]);
      timers[key] = setTimeout(() => sendChange(input), 250);
    },
    true
  );

  function setEmptyState(isEmpty) {
    document
      .querySelectorAll('cart-drawer, cart-drawer-items, cart-items, #main-cart-footer')
      .forEach((el) => el.classList.toggle('is-empty', isEmpty));
  }

  // Lixeira: remove o item pelo Shopify e tira a linha da tela (pop-up e página).
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest && event.target.closest('cart-remove-button');
      if (!button || !button.closest(SCOPE)) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      const row = button.closest('.cart-item');
      const key = row && qtyInput(row)?.dataset.quantityLineKey;
      if (!key) return;

      row.style.opacity = '0.5';
      row.style.pointerEvents = 'none';
      seq[key] = (seq[key] || 0) + 1;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then((r) => r.json())
        .then((cart) => {
          if (cart.status || cart.errors) throw new Error(cart.description || cart.errors);
          rows().forEach((r) => {
            if (qtyInput(r)?.dataset.quantityLineKey === key) r.remove();
          });
          applyCart(cart);
          if (cart.item_count === 0) {
            // Carrinho vazio: a tela "vazio" só existe no HTML novo do servidor.
            if (document.getElementById('main-cart-footer')) {
              window.location.reload();
              return;
            }
            fetch(`${routes.cart_url}?section_id=cart-drawer&t=${Date.now()}`, { cache: 'no-store' })
              .then((r) => r.text())
              .then((text) => {
                const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('.drawer__inner');
                const current = document.querySelector('#CartDrawer .drawer__inner');
                if (fresh && current) current.innerHTML = fresh.innerHTML;
                setEmptyState(true);
              })
              .catch(() => setEmptyState(true));
          }
        })
        .catch((e) => {
          console.error(e);
          row.style.opacity = '';
          row.style.pointerEvents = '';
        });
    },
    true
  );

  // Pop-up: sempre que ele for redesenhado, recalcula pelo que está na tela.
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const observer = new MutationObserver(() => {
      observer.disconnect();
      recalcFromDom();
      observer.observe(drawer, { childList: true, subtree: true });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  });
})();
